import React from 'react'
import PropTypes from 'prop-types'
import Text from '@components/Text'
import Picture from '@components/Picture'
import styles from './Team.module.scss'
import classnames from 'classnames/bind'

import Person from './Person'

const cx = classnames.bind(styles)

const Team = ({ className, list, subHeader, logos }) => {
  return (
    <div className={cx('container', className)}>
      <div className={cx('banner-container')}>
        <Picture className={cx('banner-img')} src={list[0].image.url} />
        <div className={cx('banner-text')}>
          <Text tag="h1" type="h1" className={cx('nowrap')}>
            Meet
          </Text>
          <Text tag="h1" type="h1" className={cx('nowrap', 'our-team-text')}>
            our leaders
          </Text>
          <Text tag="h3" type="h3" className={cx('banner-small-text')}>
            {subHeader.subHeader}
          </Text>
        </div>
      </div>
      <div className={cx('persons-container')}>
        <Picture className={cx('g1001-logo', 'center')} src={logos[0].file.url} alt={logos[0].description} />
        <div className={cx('list')}>
          {list &&
            list.map(item => {
              if (item.displaySection == 'A' && item.image) {
                return <Person className={cx('person')} key={item.image.url} {...item} />
              }
            })}
        </div>
        <div className={cx('divider-line')}>
          <hr></hr>
        </div>
        <Picture className={cx('dl-logo', 'center')} src={logos[1].file.url} alt={logos[1].description} />
        <div className={cx('list')}>
          {list &&
            list.map(item => {
              if (item.displaySection == 'B' && item.image) {
                return <Person className={cx('person')} key={item.image.url} {...item} />
              }
            })}
        </div>
        <div className={cx('divider-line')}>
          <hr></hr>
        </div>
        <Picture className={cx('cs-logo', 'center')} src={logos[2].file.url} alt={logos[2].description} />
        <div className={cx('list')}>
          {list &&
            list.map(item => {
              if (item.displaySection == 'C' && item.image) {
                return <Person className={cx('person')} key={item.image.url} {...item} />
              }
            })}
        </div>
        <div className={cx('divider-line')}>
          <hr></hr>
        </div>
        <Picture className={cx('cs-logo', 'center')} src={logos[3].file.url} alt={logos[3].description} />
        <div className={cx('list')}>
          {list &&
            list.map(item => {
              if (item.displaySection == 'D' && item.image) {
                return <Person className={cx('person')} key={item.image.url} {...item} />
              }
            })}
        </div>
        <div className={cx('divider-line')}>
          <hr></hr>
        </div>
        <Picture className={cx('guggenheim-logo', 'center')} src={logos[4].file.url} alt={logos[4].description} />
        <div className={cx('list')}>
          {list &&
            list.map(item => {
              if (item.displaySection == 'E' && item.image) {
                return <Person className={cx('person')} key={item.image.url} {...item} />
              }
            })}
        </div>
        {logos[5] && logos[5].description != 'placeholder' && (
          <div className={cx('divider-line')}>
            <hr></hr>
          </div>
        )}
        {logos[5] && logos[5].description != 'placeholder' && (
          <Picture className={cx('guggenheim-logo', 'center')} src={logos[5].file.url} alt={logos[5].description} />
        )}
        <div className={cx('list')}>
          {list &&
            list.map(item => {
              if (item.displaySection == 'F' && item.image) {
                return <Person className={cx('person')} key={item.image.url} {...item} />
              }
            })}
        </div>
        {logos[6] && logos[6].description != 'placeholder' && (
          <div className={cx('divider-line')}>
            <hr></hr>
          </div>
        )}
        {logos[6] && logos[6].description != 'placeholder' && (
          <Picture className={cx('guggenheim-logo', 'center')} src={logos[6].file.url} alt={logos[6].description} />
        )}
        <div className={cx('list')}>
          {list &&
            list.map(item => {
              if (item.displaySection == 'G' && item.image) {
                return <Person className={cx('person')} key={item.image.url} {...item} />
              }
            })}
        </div>
      </div>
    </div>
  )
}

Team.propTypes = {
  className: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string,
        description: PropTypes.string,
      }),
      name: PropTypes.string,
      title: PropTypes.string,
      company: PropTypes.string,
      experience: PropTypes.string,
      education: PropTypes.string,
      fullTitle: PropTypes.string,
      displaySection: PropTypes.string,
    })
  ).isRequired,
  title: PropTypes.string,
  subHeader: PropTypes.string,
}

export default Team
